/* eslint-disable no-undef */
export const options = {
  overlayBackgroundColor: '#F8F8F8',
  overlayOpacity: '0.5',
  spinnerIcon: 'ball-pulse',
  spinnerColor: '#666666',
  spinnerSize: '2x',
  OverlayIDName: 'loading-overlay',
  spinnerIDName: 'loading-spinner',
  offsetX: 0,
  offsetY: 0,
  lockScroll: true,
  overlayZIndex: 9998,
  spinnerZIndex: 9999,
}

export function startLoadingOverlay() {
  // Start the overlay
  JsLoadingOverlay.show(options)
}

export function stopLoadingOverlay() {
  // Start the overlay
  JsLoadingOverlay.hide(options)
}

export async function wrap(callable) {
  startLoadingOverlay()
  try {
    const result = await callable()
    return result
  } finally {
    stopLoadingOverlay()
  }
}



// WEBPACK FOOTER //
// ./scripts/shared/loading-overlay.js